export default __webpack_public_path__ + "static/media/Privacy_Policy.9a5560ac.pdf";